import { render, staticRenderFns } from "./common_word.vue?vue&type=template&id=1f042c23&scoped=true"
import script from "./common_word.vue?vue&type=script&lang=js"
export * from "./common_word.vue?vue&type=script&lang=js"
import style0 from "./common_word.vue?vue&type=style&index=0&id=1f042c23&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f042c23",
  null
  
)

export default component.exports